import {
  CandidateFormSubmission,
  CandidateResponse,
  EntryType
} from '@percent/partner-dashboard/services/grants/grantsService.types'

export type CandidateHeaderProps = {
  onOpenTasksView: () => void
  isTasksViewOpen: boolean
  hasTasks: boolean
  onShowComments: () => void
  commentsShown: boolean
  totalComments: number
  candidate: CandidateResponse
  activeTab: CandidateHeaderTab
  setActiveTab: (tab: CandidateHeaderTab) => void
  totalNominations: number
  totalDocuments: number
  showDocumentsTab: boolean
  formSubmissions: CandidateFormSubmission[]
  entryType: EntryType
}

export enum CandidateHeaderTab {
  ORGANIZATION_DETAILS = 'organization_details',
  SUBMITTED_INFO = 'submitted_info',
  DOCUMENTS = 'documents',
  APPLICATION = 'application',
  NOMINATIONS = 'nominations',
  REVIEWS = 'reviews',
  PAYMENT = 'payment',
  TIMELINE = 'timeline'
}

export type CandidateHeaderTabs = {
  label: string
  key: CandidateHeaderTab
}[]

export type AdminActionModalProps = {
  success: boolean
  error: boolean
  isLoading: boolean
  organisationName: string
  onSubmit: () => void
  onClose: () => void
  onSuccessClose: () => void
}
